import App from './App'
import { createApp } from 'vue'

import { CsIcon } from 'lifesci-ui'
import { bootstrap } from '@lifesci-ui/plugin/bootstrap'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import '@/assets/iconfont.css'

import Element from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/element-variables.module.scss'

import '@/styles/index.scss' // global css

import messages from '@/lang' // internationalization

import { initDic } from '@/api/common'
import { initSetting } from '@/api/setting'
import { getToken } from '@/utils/auth'

import resourceDirectives from '@/directives/resource.js'

// import { useErrorLog } from './utils/error-log'

// import { examApplicationRoutes } from '@/exam/router'

const app = createApp(App)

bootstrap(app, {
  i18n: {
    messages
  },
  router: {
    loginViewComp: import('./views/login/Login.vue'),
    registerRoute: true,
    // constantRoutes: examApplicationRoutes
  },
  modules: import.meta.glob([
    '/src/exam/views/**/**.vue'
  ]),
  settings: {
    layout: {
      cachedTagsNum: 1,
      headerToolbar: {
        message: { hidden: import.meta.env.CS_ENABLE_WS_MESSAGE === 'true' }
      }
    }
  }
})

import('./utils/error-log').then((moudel) => {
  moudel.useErrorLog(app)
})

initSetting()

if (getToken()) {
  initDic(getToken())
}

app
  // .use(VMdPreview)
  .use(Element, {
    size: Cookies.get('size') || 'default', // set element-plus default size
  })
  .component('cs-icon', CsIcon)
  .component('CsIcon', CsIcon)

app.mount('#app')


// const resourceDirectives = await import('@/directives/resource.js')
app.directive('resource', resourceDirectives)
